import { useEffect, useState } from "react";
import NewIcon from "../NewIcon";
import ProfileIcon from "../ProfileIcon";

import profiles from "../../profiles.json";

import "./index.sass";
import Pulse from "src/Component/Pulse";

interface PageChooseProfileProps {
  step: number;
  stepVisited: number[];
  setStep: (step: number) => void;
  currentUser: string;
  setCurrentUser: (user: string) => void;
}

const PageChooseProfile = ({ step, stepVisited, setStep, currentUser, setCurrentUser }: PageChooseProfileProps) => {
  const [openSlowlly, setOpenSlowlly] = useState(false);

  const handleChooseProfile = (key: string) => {
    setCurrentUser(key);
    setOpenSlowlly(false);
    setTimeout(() => {
      setStep(0);
    }, 300);
  };

  useEffect(() => {
    if (step === 1) {
      setTimeout(() => {
        setOpenSlowlly(true);
      }, 50);
    } else {
      setOpenSlowlly(false);
    }
  }, [step]);

  const countStepOccurrences = (stepVisited: number[], step: number) => stepVisited.filter((s) => s === step).length;

  return (
    <>
      {step === 1 && (
        <div className={`page-profiles ${openSlowlly ? "open" : ""}`}>
          <div className="page-profiles-title">Profiles</div>
          <div className="page-profiles-body">
            {profiles.map((profile) => {
              return (
                <div
                  onClick={() => handleChooseProfile(profile.key)}
                  className={`profil-item ${currentUser === profile.key ? "active" : ""}`}
                  key={profile.key}
                >
                  {countStepOccurrences(stepVisited, 1) <= 1 && !(currentUser === profile.key) && (
                    <Pulse style={{ width: "var(--width-200)", position: "absolute", zIndex: 0, top: "var(--height-65)" }} />
                  )}

                  <ProfileIcon
                    color={profile.color}
                    style={{
                      position: "relative",
                      width: currentUser === profile.key ? "var(--width-124)" : "var(--width-88)",
                      height: currentUser === profile.key ? "var(--height-124)" : "var(--height-88)",
                    }}
                  />
                  <div className="profil-item-name">{profile.name}</div>
                </div>
              );
            })}
            <div className={`profil-item`}>
              <NewIcon style={{ width: "var(--width-88)", height: "var(--height-88)" }} />
              <div className="profil-item-name">New</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PageChooseProfile;
